<main class="mb-3 w-100 dropdown mx-auto d-flex flex-column gap-3" style="max-width: 480px">
  <h5 class="border-bottom pb-2">Einstellungen für Bidirektionales Laden</h5>
  <div>
    <div class="form-group">
      <div class="d-flex align-items-center gap-2 mb-1">
        <app-svg source="icons/feather/cpu" width="18" height="18"></app-svg>
        <span i18n="@@SelectedGatewayLabel">Ausgewähltes Gateway</span>
      </div>
      <ng-select *ngIf="blackboxes.length > 0; else noBlackboxesAvailable" [items]="blackboxes" id="blackbox"
        [placeholder]="blackboxSelectPlaceholder" multiple="false" [closeOnSelect]="false" [clearSearchOnAdd]="true"
        [hideSelected]="true" appendTo="body" bindLabel="serialNumber" notFoundText="Kein Gateway vorhanden"
        (change)="onBlackboxSelected($event)">
      </ng-select>
      <ng-template #noBlackboxesAvailable>
        <input disabled [placeholder]="blackboxSelectPlaceholder" class="form-control" />
      </ng-template>
    </div>
  </div>

  <!-- ToggleBtn -->
  <div class="d-flex flex-column">
    <div class="d-flex align-items-center gap-2 mb-1">
      <app-svg source="icons/feather/sliders" width="18" height="18"></app-svg>
      <span i18n="@@GatewayModeLabel"> Steuerung </span>
    </div>
    <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
      <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" [value]="1"
        [(ngModel)]="selectedBidiModeId" />
      <label class="btn btn-outline-primary" for="btnradio1">Ausgeschaltet</label>

      <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" [value]="2"
        [(ngModel)]="selectedBidiModeId" />
      <label class="btn btn-outline-primary" for="btnradio2">Automatisch</label>

      <input type="radio" class="btn-check" name="btnradio" id="btnradio3" autocomplete="off" [value]="3"
        [(ngModel)]="selectedBidiModeId" />
      <label class="btn btn-outline-primary" for="btnradio3">Manuell</label>
    </div>
  </div>

  <!-- Auswahl Ladestationen -->
  <div class="d-flex flex-column">
    <!-- <div class="form-group">
      <label i18n="@@SelectedChargingStationsLabel">
        Ausgewählte Ladestationen
      </label>
      <ng-select *ngIf="chargingStations.length > 0; else noChargingStationsAvailable" [items]="chargingStations"
        id="chargingStations" [placeholder]="chargingStationsSelectPlaceholder" multiple="true" [closeOnSelect]="false"
        [clearSearchOnAdd]="true" [hideSelected]="true" appendTo="body" bindLabel="name"
        notFoundText="Keine Ladestationen vorhanden" formControlName="selectedChargingStations">
        <ng-template ng-option-tmp let-item="item">
          <span class="text-muted" style="display: inline-block; width: 160px">{{item.model?.name}}</span>
          <strong style="display: inline-block;">&emsp;{{item.name}}</strong>
        </ng-template>
      </ng-select>
      <ng-template #noChargingStationsAvailable>
        <input disabled [placeholder]="chargingStationsSelectPlaceholder" class="form-control">
      </ng-template>
    </div> -->
    <div class="d-flex align-items-center gap-2 mb-1">
      <app-svg source="icons/feather/charging-station" width="18" height="18"></app-svg>
      <span i18n="@@SelectedChargingStationsLabel">
        Ausgewählte Ladestationen
      </span>
    </div>
    <button class="d-flex align-items-center btn btn-outline-primary text-dark" (click)="openScsDialog()">
      {{ chargingStations.length }} Ladestationen ausgewählt
    </button>
  </div>

  <!-- Zeil-Ladeleistung -->
  <div class="d-flex flex-column">
    <div class="d-flex align-items-center gap-2 mb-1">
      <app-svg source="icons/feather/target" width="18" height="18"></app-svg>
      <span i18n="@@TargetChargingPowerLabel"> Ziel-Ladeleistung </span>
      <strong class="bg-light border-0 rounded-pill px-3 d-flex ms-auto">
        {{ targetPowerSliderValue | number : "1.1-1" }} kW
      </strong>
    </div>

    <div class="mb-3">
      <input type="range" id="customRange1" [min]="maxBidiDischargePowerSum" [max]="maxBidiChargePowerSum" step="0.5"
        [(ngModel)]="targetPowerSliderValue" [value]="targetPowerSliderValue" [disabled]="selectedBidiModeId !== 3" />
      <div class="d-flex justify-content-between">
        <span>{{ maxBidiDischargePowerSum | number : "1.1-1" }} kW</span>
        <span>0,0 kW</span>
        <span>{{ maxBidiChargePowerSum | number : "1.1-1" }} kW</span>
      </div>
    </div>
  </div>

  <!-- Dual-Range-Slider -->
  <div class="d-flex flex-column">
    <div class="d-flex align-items-center gap-2">
      <app-svg source="icons/feather/bar-chart" width="18" height="18"></app-svg>
      <span i18n="@@SocRangeLabel"> SoC-Bereich </span>
      <strong class="bg-light border-0 rounded-pill px-3 d-flex ms-auto">
        {{ currentValues.from | number : "1.0" }}&mdash;{{
        currentValues.to | number : "1.0"
        }}%
      </strong>
    </div>

    <div class="mt-2">
      <app-range-slider [disabled]="selectedBidiModeId != 2" [rangeValues]="currentValues"
        (valueChange)="onSliderValueChange($event)"></app-range-slider>
    </div>
  </div>

  <div>
    <button [disabled]="saveDisabled" (click)="saveSettings()"
      class="btn btn-warning">Speichern</button>
  </div>
</main>
